import { render, staticRenderFns } from "./Proforma.vue?vue&type=template&id=a3731af8&scoped=true"
import script from "./Proforma.vue?vue&type=script&lang=js"
export * from "./Proforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3731af8",
  null
  
)

export default component.exports